module.exports = __webpack_public_path__ + "static/media/merve.4bd7a16a.jpg";